import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import LayeredStack from "@/components/LayeredStack";
import { Radio, Trophy, Gamepad2, Cpu, Swords, User } from "lucide-react";

function SpotlightCard({ icon: Icon, title, win, tint, onView }) {
  return (
    <div className="panel-glow p-5 text-center relative overflow-hidden" style={{ boxShadow: `0 0 30px -10px ${tint}` }}>
      <div className="absolute inset-x-0 top-0 h-1" style={{ background: tint }} />
      <Icon className="w-9 h-9 mx-auto mb-2" style={{ color: tint }} />
      <div className="label-cap" style={{ color: tint }}>{title}</div>
      {win ? (
        <>
          {win.pet && <div className="my-3 mx-auto w-fit rounded-lg overflow-hidden border" style={{ borderColor: tint }}><LayeredStack layers={win.pet.layers} core={win.pet.core_color} rig={win.pet.rig} cpu={win.pet.cpu} size={96} /></div>}
          <div className="font-head font-black text-xl mt-2">{win.robot || win.name}</div>
          {win.robot && <div className="label-cap text-[9px] flex items-center justify-center gap-1"><User className="w-3 h-3" />{win.name}</div>}
          <div className="text-sm text-muted-foreground mt-1">{win.detail}</div>
          {win.pet_id && <button onClick={() => onView(win.pet_id)} className="text-xs text-primary hover:underline mt-2">View robot →</button>}
          <div className="mt-3 inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold" style={{ background: `${tint}22`, color: tint }}><Trophy className="w-3.5 h-3.5" /> Trophy awarded</div>
        </>
      ) : <div className="text-sm text-muted-foreground py-6">No winner this cycle yet.</div>}
    </div>
  );
}

export default function MainframeNews() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/mainframe-news").then((r) => {
      setD(r.data);
      if (r.data.refreshed) toast.success("📡 A new Mainframe Spotlight has been broadcast station-wide!");
    });
  }, []);
  if (!d) return null;
  const s = d.spotlight;

  return (
    <div data-testid="mainframe-news-page" className="max-w-4xl mx-auto">
      <span className="label-cap text-primary flex items-center gap-2"><Radio className="w-4 h-4" /> Mainframe Broadcast // Weekly Spotlight</span>
      <h1 className="font-head font-black text-3xl sm:text-4xl mt-2 mb-1">System Spotlight</h1>
      <p className="text-muted-foreground mb-6">Auto-curated every 7 days ({d.week}). The station's finest pilots are stamped with a permanent spotlight trophy.</p>

      <div className="grid md:grid-cols-3 gap-4">
        <SpotlightCard icon={Gamepad2} title="Pilot of the Week" win={s.pilot} tint="#FFB300" onView={(id) => navigate(`/app/robots/lookup/${id}`)} />
        <SpotlightCard icon={Cpu} title="Chassis Master" win={s.chassis} tint="#4dd0ff" onView={(id) => navigate(`/app/robots/lookup/${id}`)} />
        <SpotlightCard icon={Swords} title="Arena Warlord" win={s.warlord} tint="#ff3b4e" onView={(id) => navigate(`/app/robots/lookup/${id}`)} />
      </div>
    </div>
  );
}
